import React, { Component } from 'react'
import classNames from 'classnames'
import { Button } from '@winnin/winnin_ui.components.button'
import { Title } from '@winnin/winnin_ui.components.title'
import { WithLegend } from '@winnin/winnin_ui.components.with-legend'

import { withTolgee, T } from 'lib/tolgee'
import { Filters, TOLGEE_GLOBALS } from 'utils'

import './index.scss'

class SelectAgesButtons extends Component {
  isInFilter = option => {
    const { filter } = this.props
    if (!Array.isArray(filter)) {
      return filter?.value === option?.value
    }
    return filter.reduce((acc, opts) => {
      if (opts?.value === option?.value) acc = true
      return acc
    }, false)
  }

  isAllOption = ({ value }, filterType) => {
    const def = Filters.getDefaultFilter({
      group: 'audienceFilters',
      filter: filterType,
    }).value

    return value === def
  }

  change = option => {
    const { filter, setFilter, filterType } = this.props
    const isInFilter = this.isInFilter(option)
    const isAllOption = this.isAllOption(option, filterType)

    if (isInFilter) {
      if (filter.length === 1) {
        return
      }

      if (filter.filter) {
        setFilter(filter.filter(opts => opts.value !== option.value))
      }
    } else {
      if (isAllOption) {
        setFilter([option])
      } else {
        const withoutAllOpts = (Array.isArray(filter) ? filter : [filter]).filter(f => f.value.length)
        setFilter([...withoutAllOpts, option])
      }
    }
  }

  render() {
    const options = Filters.get('audienceFilters', 'audienceAges')

    const { audienceFilterProp, containerClass, t } = this.props
    const container = classNames('container-ages-buttons', { [containerClass]: containerClass })

    return (
      <>
        <Title tag="h4" weight="regular" className="audience-options-item-label">
          <T keyName={TOLGEE_GLOBALS.ages.key}>{TOLGEE_GLOBALS.ages.defaultValue}</T>
        </Title>
        <div className={container}>
          {options.map(option => {
            const active = this.isInFilter(option)
            const _props = active ? { variation: 'primary' } : { variation: 'primary', appearance: 'outline' }
            const stylePropsAudienceFilter = active
              ? { variation: 'primary' }
              : { variation: 'faded', appearance: 'outline' }
            const label = option.label === 'All Ages' ? t(TOLGEE_GLOBALS.allAges) : option.label

            return (
              <WithLegend label={label} active={active} key={option.label}>
                <Button
                  className="AudienceFilterDropdownContent-filter-btn"
                  onClick={() => {
                    this.change(option)
                  }}
                  {...(!audienceFilterProp ? { ..._props } : { ...stylePropsAudienceFilter })}
                >
                  <T keyName={option.tolgee.key ?? ''}>{option.tolgee.defaultValue ?? ''}</T>
                </Button>
              </WithLegend>
            )
          })}
        </div>
      </>
    )
  }
}

SelectAgesButtons.propTypes = {}

SelectAgesButtons.defaultProps = {
  filterType: 'audienceAges',
  audienceFilterProp: false,
}

SelectAgesButtons.displayName = 'SelectAgesButtons'

export default withTolgee(SelectAgesButtons)
